<template>
  <div class="resource-box">
    <!-- 图片 -->
    <img v-if="resourceUrl[0].picResourceType===1"
         :src="alarmImage(resourceUrl[0])"
         onerror="this.src='/images/theme/newDark/default.png'" />
    <!-- 视频 -->
    <video preload="none"
           id="videoDom"
           v-if="resourceUrl[0].picResourceType===2"
           :src="$utils.Bus.imgPath(resourceUrl[0].resourceCode)"
           controls="controls"></video>
    <img v-if="resourceUrl[0].picResourceType!=1&&resourceUrl[0].picResourceType!=2"
         :src="alarmImage(resourceUrl[0])"
         onerror="this.src='/images/theme/newDark/default.png'" />
  </div>
</template>
<script>
import { Cache, Bus } from '$utils'
export default {
  props: {
    // 该行数据
    resourceUrl: {
      type: Array,
      default: function () {
        return []
      }
    },
    // 告警详情
    alarmInfo: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      types: {
        image: 'image',
        video: 'video'
      }
    }
  },
  mounted () {
    console.log('-------视频的this.resourceUrl地址======', this.resourceUrl[0].resourceCode);
  },
  methods: {
    getImgPath (item) {
      return item ? Bus.imgPath(item) : "";
    },
    alarmImage (item) {
      console.log(item, '(((((')
      const token = Cache.get('access_token')
      let url = '';
      switch (item.picResourceType) {
        case 1: url = `/bas/safeEvent/picStreamInfo.json?resourceCode=${item.resourceCode}&ticket=${token}`;
          break;
        case 3: url = `/bas/safeEvent/picStreamInfo.json?alarmId=${item.alarmId}&alarmType=${item.alarmType}&deviceId=${item.deviceId}&picResourceType=${item.picResourceType}&ticket=${token}`;
          break;
        case 4: url = `/bas/safeEvent/picStreamInfo.json?alarmId=${item.alarmId}&alarmType=${item.alarmType}&picResourceType=${item.picResourceType}&ticket=${token}`;
          break;
        default: url = `/bas/safeEvent/picStreamInfo.json?picResourceType=${item.picResourceType}&alarmType=${this.alarmInfo.alarmType}&alarmId=${this.alarmInfo.alarmId}&ticket=${token}&resourceCode=${item.resourceCode}`;
      }
      console.log(url, '********')
      return url
    },
    stopVideo () {
      if (document.getElementById('videoDom')) {
        document.getElementById('videoDom').pause();
      }
    }
  }
}
</script>
<style>
.resource-box {
  width: 500px;
}
.resource-box img,
.resource-box video {
  width: 100%;
  max-height: 600px;
}
</style>

